module.exports = __webpack_public_path__ + "static/img/tp3.7297fa0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tp3.png
// module id = PsrY
// module chunks = 3